import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <img
      src="/e8solutionslogo.png"
      alt="E8 Solutions"
      className={`h-12 w-auto transition-all duration-300 ${className}`}
    />
  );
};

export default Logo;
